@if (img) {
  <div class="card card-photo" (click)="onItemClick()">
    <div
      class="card-background"
      [ngStyle]="{ 'background-image': 'url(' + img + '?w=300&h=200&m=2' + addWebp + ')' }"
    ></div>
  </div>
}
